import { Business, Country } from '@admin/models';
import { Component, DestroyRef, Inject, inject, signal } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ToastAlertService } from '@core/index';
import { MatCheckboxModule } from '@angular/material/checkbox';

import {
  ButtonComponent,
  InputComponent,
  SelectComponent,
  TextAreaComponent,
  TitleComponent,
} from '@shared/components';
import { BusinessService } from '@admin/services';

@Component({
  selector: 'app-edit-licenses',
  templateUrl: './editLicenses.component.html',
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogContent,
    InputComponent,
    SelectComponent,
    TextAreaComponent,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
    MatListModule,
    MatSelectModule,
    MatCheckboxModule,
  ],
  standalone: true,
})
export class EditLicensesComponent {
  lunes: boolean = false;
  private formBuilder = inject(FormBuilder);
  public operation = '';
  companyForm!: FormGroup;
  buildingForm!: FormGroup;
  public workplaceTypeForm!: FormGroup;
  public floorForm!: FormGroup;
  private dialogRef = inject(MatDialogRef<EditLicensesComponent>);

  //SERVICES
  private alertService = inject(ToastAlertService);
  private destroyRef = inject(DestroyRef);
  #businessService = inject(BusinessService);

  //VARS
  public countries = signal<Country[]>([]);
  public reader = signal<void | null>(null);

  imageError: string | null = null;
  imgBase64 = signal<string>('');

  constructor(@Inject(MAT_DIALOG_DATA) public data: Business) {
    this.buildForm();
  }

  public onSubmit() {
    this.companyForm.markAsTouched;

    if (this.companyForm.valid) {
      this.#businessService
        .putUsersAccount(
          this.companyForm.value.idBusiness,
          this.companyForm.value.usersCount,
          this.companyForm.value.sendMail
        )
        .subscribe({
          next: ({ code, detail }) => {
            if (code === 10000) {
              this.dialogRef.close(true);
              this.alertService.sucess('Licencias actualizadas exitosamente');
            } else {
              this.alertService.error(detail);
            }
          },
          error: error => {
            this.alertService.error(error);
          },
        });
    }
  }

  clearForm() {
    this.buildForm();
  }

  private buildForm(): void {
    if (this.data) {
      this.companyForm = this.formBuilder.group({
        idBusiness: [this.data.idBusiness],
        sendMail: [true, Validators.required],
        usersCount: [
          this.data.usersCount,
          [
            Validators.required,
            Validators.min(1),
            Validators.pattern('[0-9]*'),
          ],
        ],
      });
    }
  }

  preventDecimal(event: KeyboardEvent) {
    if (
      event.key === '.' ||
      event.key === ',' ||
      event.key === 'e' ||
      event.key === '-' ||
      event.key === '+'
    ) {
      event.preventDefault();
    }
  }
}
